/**
 * 字符串按步长分割为数组（支持2位一组）
 * @param {string} str - 输入的字符串（必须为数字字符串）
 * @returns {number[]} 分割后的数字数组
 */
export function splitStringByStep(str) {
  // 处理空字符串情况
  if (!str) {
    return []
  }
  str = String(str)
  const result = []
  const length = str.length
  // 从2位开始，每次增加2位
  for (let i = 2; i <= length; i += 2) {
    result.push(Number(str.substring(0, i)))
  }
  // 如果字符串长度是奇数，或者长度不足2位，添加完整字符串
  // 确保最后一个元素总是完整的原始字符串
  if (length % 2 !== 0 || length < 2) {
    result.push(Number(str))
  }
  return result
}
